import type { RouteLineString } from '@sixam/shared/route-core';

/**
 * A lightweight preview derived from the supplied "6am Run Club Monday Run.gpx".
 * The full GPX remains importable through the route library; this sampled trace
 * keeps the event editor preview small while preserving the course shape.
 */
export const SIXAM_MONDAY_ROUTE = {
  distanceM: 3_668,
  elevationGainM: 21,
  geometry: {
    type: 'LineString',
    coordinates: [
      [100.544466, 13.732297],
      [100.5447614, 13.732517],
      [100.5447239, 13.7331397],
      [100.5448446, 13.7333716],
      [100.5450296, 13.7334654],
      [100.5450752, 13.7336817],
      [100.5455473, 13.7339396],
      [100.5460516, 13.7340777],
      [100.551227, 13.733892],
      [100.551716, 13.733775],
      [100.552032, 13.733752],
      [100.552488, 13.73351],
      [100.552402, 13.733058],
      [100.552481, 13.733244],
      [100.55296, 13.733229],
      [100.552475, 13.733331],
      [100.552214, 13.732869],
      [100.552257, 13.732392],
      [100.552351, 13.7315],
      [100.554053, 13.731541],
      [100.555083, 13.731566],
      [100.555055, 13.732251],
      [100.555016, 13.733469],
      [100.553508, 13.733415],
      [100.553282, 13.733576],
      [100.55283, 13.733395],
      [100.552936, 13.733231],
      [100.552402, 13.733058],
      [100.552507, 13.733484],
      [100.551987, 13.73385],
      [100.546272, 13.734078],
      [100.5455205, 13.7339266],
      [100.5451664, 13.7336556],
      [100.5449814, 13.7336269],
      [100.5447936, 13.7335019],
      [100.5447292, 13.7333508],
      [100.5447534, 13.7325144],
      [100.5444691, 13.7322955],
    ],
  } satisfies RouteLineString,
  name: '6am Monday Run',
} as const;
